import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import MuiButton from '@material-ui/core/Button';
import { useTranslation } from 'utils/modifiedTranslation';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';

export const LoginButton = ({ color }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <MuiButton
      onClick={() => {
        dispatch(push(ROUTE_PATH[ROUTE_NAME.LOGIN]));
      }}
      color={color}
    >
      {t('general.login')}
    </MuiButton>
  );
};

LoginButton.propTypes = {
  color: PropTypes.string,
};
